import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    messages: [],
    data: {
      Main: {}
    },
    axiosInstances: 0,
    authenticated: false,
    route: {},
    model: ''
  },
  actions: {
    async init ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const app = this
        Vue.prototype.$http.get(process.env.API_URL + 'handshake')
          .then(function (response) {
            app.commit('addAppData', response.data)
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    async removeMediaFromRoom ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const store = this
        Vue.prototype.$http.post(process.env.API_URL + 'rooms/' + this.state.data.Room.title + '/deletecontent/' + data.content.id)
          .then(function (response) {
            store.commit('removeContentFromRoom', response.data.Room)
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    async addMediaToRoom ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('data', JSON.stringify(data.content))
        formData.append('media', data.content.uploadedmedia)
        console.log(data.content.sound)
        const url = process.env.API_URL + 'rooms/' + this.state.data.Room.title + '/newcontent'

        Vue.prototype.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {
          commit('updateRoom', response.data.Room)
          resolve(response)
        }).catch(function (error) {
          reject(error)
        })
      })
    },
    async fetchData ({ commit }, { self }) {
      return new Promise((resolve, reject) => {
        if (!this.state.authenticated) {
          this.state.route.commit = commit
          this.state.route.self = self
          return reject
        }

        if (self.hasOwnProperty('meta') && self.meta.apiEndpoint) {
          console.log('Yes we should!' + self.meta.apiEndpoint)

          let url = process.env.API_URL + self.meta.apiEndpoint
          console.log('Param is: ' + self.meta.withParam)
          if (self.meta.withParam) {
            const apiUrl = process.env.API_URL.substring(0, process.env.API_URL.length - 1)
            url = apiUrl + self.path
            console.log(url)
          }
          if (self.params.title) {
            url = url + '/' + self.params.title
          }

          // build a query string from the self.query array
          if (self.query) {
            const str = []
            for (const querystring in self.query) {
              if (self.query.hasOwnProperty(querystring)) {
                str.push(encodeURIComponent(querystring) + '=' + encodeURIComponent(self.query[querystring]))
              }
            }
            url = url + '?' + str.join('&')
          }
          console.log(self)
          const store = this
          if (!store.state.data.Rooms) {
            Vue.prototype.$http.get(process.env.API_URL + 'rooms')
              .then((response) => {
                commit('updateData', response.data)
              })
              .catch((error) => {
                console.log(error.response)
              })
          }
          Vue.prototype.$http.get(url)
            .then(function (response) {
              commit('updateData', response.data)
              resolve()
            }).catch(function (error) {
              console.log(error.response)
              if (error.response.status === 401) {
                // localStorage.removeItem('accessToken')
                // store.commit('authenticated', false)
                store.commit('addMessage', {})
              }
            })
        }
      })
    },
    async newSchool ({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.post(process.env.API_URL + 'schools', data.data)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    },
    async updateSettings ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log('Updating settings')
        Vue.prototype.$http.post(process.env.API_URL + 'settings', data)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    },
    async extendCode ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log('Extending code')
        console.log(data)
        Vue.prototype.$http.post(process.env.API_URL + 'school_user/extend', data)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    },
    async removeSchool ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log('Removing school')
        console.log(data)
        Vue.prototype.$http.post(process.env.API_URL + 'schools/delete', data)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    },
    async sendTeacherCode ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log('Sending teacher code')
        Vue.prototype.$http.get(process.env.API_URL + 'schools/send_teacher_code/' + data.id)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    },
    async sendClassCode ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log('Sending class code')
        Vue.prototype.$http.get(process.env.API_URL + 'schools/send_class_code/' + data.id)
          .then((response) => {
            resolve(response)
          })
          .catch((response) => {
            reject(response.error)
          })
      })
    }
  },
  mutations: {
    clearMessages: function (state) {
      state.messages = []
    },
    addMessage: function (state, message) {
      if (!message.hasIcon) {
        message.hasIcon = false
      }
      if (!message.type) {
        message.type = null
      }
      this.state.messages.push(message)
    },
    removeMessage: function (state, index) {
      state.messages.splice(index, 1)
    },
    resetRoomData (state) {
      state.data.room = {}
    },
    updateData: function (state, data) {
      this.commit('model', Object.keys(data)[0])
      Vue.set(this.state, 'data', { ...this.state.data, ...data })
    },
    updateModelData: function (state, data, name = null) {
      if (this.state.model) {
        this.state.data[this.state.model] = data[this.state.model]
      } else {
        this.state.data = { ...data, ...this.state.data }
      }
    },
    addAxiosInstance: function (state) {
      this.state.axiosInstances++
    },
    removeAxiosInstance: function (state) {
      this.state.axiosInstances--
    },
    authenticated: function (state, data) {
      this.state.authenticated = data
      if (this.state.authenticated) {
        // we have recently been authenticated
        if (this.state.route.hasOwnProperty('self')) {
          // if we have a saved route that could not be reached before login
          console.log('FETCHING DATA')
          this.dispatch('fetchData', { self: this.state.route.self }).then(() => this.state.route.commit)
          this.state.route = {}
        }
      }
    },
    model: function (state, data) {
      this.state.model = data
    },
    updateRoom: function (state, room) {
      Vue.set(this.state.data, 'Room', room)
    },
    removeContentFromRoom: function (state, room) {
      Vue.set(this.state.data, 'Room', room)
      // this.state.data.Room.groups[data.data.group].splice(data.key, 1)
    },
    addAppData: function (state, data) {
      // Vue.set(state.data, 'Main', data)
      state.data.Main = data
    }
  }
})
